module.exports = __webpack_public_path__ + "static/img/icon_insta.307d746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_insta.png
// module id = H7AC
// module chunks = 8